<div>
	<lib-card [isForm]="true">
		<ui-file-form-field
			[validation]="'images'"
			[title]="'Logo'"
			[maxFiles]="1"
			[imageCrop]="logoCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.logo)"
			[valueAsSignal]="form.logo"
			(valueChange)="handleUploadImage($event, form.logo)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			[validation]="'images'"
			[title]="'Text logo light'"
			[maxFiles]="1"
			[isRequired]="false"
			[imageCrop]="textLogoCrop"
			[uploadFunction]="getUploadFunction(form.textLogoLight)"
			[valueAsSignal]="form.textLogoLight"
			(valueChange)="handleUploadImage($event, form.textLogoLight)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			[validation]="'images'"
			[title]="'Text logo dark'"
			[maxFiles]="1"
			[isRequired]="false"
			[imageCrop]="textLogoCrop"
			[uploadFunction]="getUploadFunction(form.textLogoDark)"
			[valueAsSignal]="form.textLogoDark"
			(valueChange)="handleUploadImage($event, form.textLogoDark)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'App version'"
			[isRequired]="true"
			[valueAsSignal]="form.appVersion"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Main title'"
			[isRequired]="true"
			[valueAsSignal]="form.mainTitle"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Main subtitle'"
			[isRequired]="true"
			[valueAsSignal]="form.mainSubtitle"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Cta title'"
			[isRequired]="true"
			[valueAsSignal]="form.ctaTitle"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Price'"
			[isRequired]="true"
			[valueAsSignal]="form.price"
		></ui-text-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'Main teaser desktop'"
			[maxFiles]="1"
			[imageCrop]="desktopImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.mainTeaserDesktop)"
			[valueAsSignal]="form.mainTeaserDesktop"
			(valueChange)="handleUploadImage($event, form.mainTeaserDesktop)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'Main teaser mobile'"
			[maxFiles]="1"
			[imageCrop]="mobileImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.mainTeaserMobile)"
			[valueAsSignal]="form.mainTeaserMobile"
			(valueChange)="handleUploadImage($event, form.mainTeaserMobile)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Various images'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[title]="'Helpdesk image'"
			[maxFiles]="1"
			[imageCrop]="helpdeskCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.helpdeskImage)"
			[valueAsSignal]="form.helpdeskImage"
			(valueChange)="handleUploadImage($event, form.helpdeskImage)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'Bot image'"
			[maxFiles]="1"
			[imageCrop]="botCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.botImage)"
			[valueAsSignal]="form.botImage"
			(valueChange)="handleUploadImage($event, form.botImage)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'No data image'"
			[maxFiles]="1"
			[imageCrop]="noDataImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(form.noDataImage)"
			[valueAsSignal]="form.noDataImage"
			(valueChange)="handleUploadImage($event, form.noDataImage)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Session images'" class="push-top-md">
		@for (sessionItem of sessionCardItems; track sessionItem.title; let first =$first) {
		<ui-file-form-field
			[class.push-top-md]="!first"
			[validation]="'images'"
			[title]="sessionItem.title"
			[maxFiles]="1"
			[imageCrop]="sessionImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(sessionItem.image)"
			[valueAsSignal]="sessionItem.image"
			(valueChange)="handleUploadImage($event, sessionItem.image)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
		}
	</lib-card>

	@for (featureItem of featureFormItems; track featureItem.id) {
	<lib-card [isForm]="true" [title]="featureItem.id" class="push-top-md">
		<ui-text-form-field
			[title]="'Title'"
			[isRequired]="true"
			[valueAsSignal]="featureItem.title"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Text'"
			[isRequired]="true"
			[valueAsSignal]="featureItem.text"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Icon'"
			[valueAsSignal]="featureItem.icon"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'Desktop image'"
			[maxFiles]="1"
			[imageCrop]="desktopImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(featureItem.imageDesktop)"
			[valueAsSignal]="featureItem.imageDesktop"
			(valueChange)="handleUploadImage($event, featureItem.imageDesktop)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-file-form-field
			class="push-top-md"
			[validation]="'images'"
			[title]="'Mobile image'"
			[maxFiles]="1"
			[imageCrop]="mobileImageCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(featureItem.imageMobile)"
			[valueAsSignal]="featureItem.imageMobile"
			(valueChange)="handleUploadImage($event, featureItem.imageMobile)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>
	}

	<lib-card [isForm]="true" [title]="'Other'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[title]="'AI assistant image'"
			[maxFiles]="1"
			[isRequired]="false"
			[imageCrop]="mobileImageCrop"
			[uploadFunction]="getUploadFunction(form.aiAssistantImage)"
			[valueAsSignal]="form.aiAssistantImage"
			(valueChange)="handleUploadImage($event, form.aiAssistantImage)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Actions'" class="push-top-md">
		<ui-form-save-button
			[title]="'Save'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
</div>
